import * as React from 'react';
import {useState} from 'react'
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
// redux
import { useSelector, useDispatch } from 'react-redux';
import KeyOutlinedIcon from '@mui/icons-material/KeyOutlined';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import ChildCareOutlinedIcon from '@mui/icons-material/ChildCareOutlined';
import logo from '@images/logo-tns.png'
import useStyles from "@hooks/useStyles";
import CommonDrawer from './CommonDrawer';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import UnsubscribeOutlinedIcon from '@mui/icons-material/UnsubscribeOutlined';
import UnsubscribeOutlined from '@mui/icons-material/UnsubscribeOutlined';
import WebService from '@util/webService'
import CottageOutlinedIcon from '@mui/icons-material/CottageOutlined';
import { isCompanyRepManager, isAdmin } from '@util/helper';
const drawerWidth = 240;

export default function ProfileDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const [directSchools, set_directSchools] = useState([])
  const [entrustSchools, set_entrustSchools] = React.useState([])
  const defSx = {color:'#212121', fontSize:20}
  const defIcon = <LabelOutlinedIcon size='small' sx={{color:'#212121'}}/>

  const [isDirectRequester, set_isDirectRequester] = useState(false)
  const [isCompanyRequester, set_isCompanyRequester] = useState(false)
  const [isAnyRepManager, set_isAnyRepManager] = useState(false)
  const sideMenuUser = [
    {text:'기본정보',   to:'/profile/user', visible: true, icon:<KeyOutlinedIcon size='small' sx={defSx}/> },
  ]

  const sideMenu = [
    {text:'divider', visible: true},
    {text:'기본 정보',   to:'/profile/user', visible: account.user.statCode === 'S001', icon:<PermIdentityIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'직영학교 등록',   to:'/profile/direct', visible: account.user.statCode === 'S001', icon:<CottageOutlinedIcon size='small' sx={defSx}/>},
    // {text:'매니저 현황',   to:'/profile/direct/manager', visible: account.user.statCode === 'S001' && isDirectRequester},
    {text:'강사 현황',   to:'/profile/direct/teacher', visible: (account.user.statCode === 'S001' && isDirectRequester) || isAdmin(account)},
    {text:'divider', visible: true},

    {text:'회사 등록',   to:'/profile/company', visible: account.user.statCode === 'S001', icon:<ApartmentOutlinedIcon size='small' sx={defSx}/>},
    {text:'위탁 대상 학교',   to:'/profile/company/school', visible: account.user.statCode === 'S001' && (isCompanyRequester || isAnyRepManager )},
    {text:'매니저 현황',   to:'/profile/company/manager', visible: account.user.statCode === 'S001' && (isCompanyRequester || isAnyRepManager) },
    {text:'강사 현황',   to:'/profile/company/teacher', visible: account.user.statCode === 'S001' && (isCompanyRequester || isAnyRepManager) },
    {text:'divider', visible: true},

    {text:'매니저 일터',   to:'/profile/manager', visible: account.user.statCode === 'S001', icon:<BadgeOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'출강 학교',   to:'/profile/teacher', visible: account.user.statCode === 'S001', icon:<SchoolOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'우리 아이',   to:'/profile/gdn', visible: account.user.statCode === 'S001', icon:<ChildCareOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'약관',   to:'/profile/agmt', visible: true, icon:<HandshakeOutlinedIcon size='small' sx={defSx}/>},
    {text:'divider', visible: true},

    {text:'회원 탈퇴',   to:'/profile/leave', visible: true, icon:<UnsubscribeOutlined size='small' sx={defSx}/>},
    {text:'divider', visible: true},
  ]

  const fetchReqComanies = async() => {
    const url = `/company/req/user/${account.user.id}`
    const resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage)
      const records = JSON.parse(repMessage.records)
      if(records.length > 0) {
        set_isCompanyRequester(true)
      }
    }
  }



  const onLoad = async () => {
    fetchReqComanies()

    const directSchools = account.schoolRelationList.filter(r => r.rltnCode === 'S001').map(it => it.school)
    set_directSchools(directSchools)
    if(isCompanyRepManager(account) || isAdmin(account)) {
      set_isAnyRepManager(true)
    }
  }
 
  React.useEffect(() => {
    if(directSchools.length > 0) {
      set_isDirectRequester(true)
    }
    else {
      set_isDirectRequester(false)
    }
  }, [directSchools])

  React.useEffect(()=> {
    onLoad()
  }, [])

  return (
    <CommonDrawer sideMenu={sideMenu}  title={'마이메뉴'} sideBgColor='#fafafa'/>
	)
}
